import { ManagementTranslationDTO } from "../domain/models/dto/ManagementDTO";
import { IFile } from "../domain/models/File";
import { IManagement } from "../domain/models/Management";
import { BaseModelImpl } from "./BaseModelImpl";

export class ManagementModel
    extends BaseModelImpl<IManagement>
    implements IManagement
{
    id: string;
    files?: IFile[];

    translations: ManagementTranslationDTO[];
    availableLangs?: string[];
    isActive: boolean;

    updatorId?: string;
    creatorId: string;
    createdAt?: Date;
    updatedAt?: Date;

    constructor(data?: IManagement) {
        super();
        this.assignData(data);
    }
}
